/* EaseEase Share Cart v1
   - /cart: "Share this cart" button → link that rebuilds the same cart (items, quantities,
     Live Product Options properties) for whoever opens it.
   - /cart?ee_share=…: banner asking the visitor to add the shared items to their cart.
   No server: the cart is compressed into the link itself. */
(function () {
  'use strict';

  var PARAM = 'ee_share';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SHARE_ICON = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4"/></svg>';

  function $(s, r) { return (r || document).querySelector(s); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function track(name, data) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {} }

  /* ---------- encode / decode (deflate + base64url when the browser supports it) ---------- */
  function toB64url(bytes) { var s = ''; for (var i = 0; i < bytes.length; i++) s += String.fromCharCode(bytes[i]); return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); }
  function fromB64url(str) { str = str.replace(/-/g, '+').replace(/_/g, '/'); while (str.length % 4) str += '='; var bin = atob(str), out = new Uint8Array(bin.length); for (var i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i); return out; }
  function encode(obj) {
    var bytes = new TextEncoder().encode(JSON.stringify(obj));
    if (!window.CompressionStream) return Promise.resolve('j' + toB64url(bytes));
    var stream = new Blob([bytes]).stream().pipeThrough(new CompressionStream('deflate-raw'));
    return new Response(stream).arrayBuffer().then(function (buf) { return 'z' + toB64url(new Uint8Array(buf)); });
  }
  function decode(str) {
    var kind = str.charAt(0), bytes = fromB64url(str.slice(1));
    var p = kind === 'z'
      ? new Response(new Blob([bytes]).stream().pipeThrough(new DecompressionStream('deflate-raw'))).arrayBuffer().then(function (b) { return new Uint8Array(b); })
      : Promise.resolve(bytes);
    return p.then(function (b) { return JSON.parse(new TextDecoder().decode(b)); });
  }

  /* ---------- styles ---------- */
  function injectStyles() {
    if ($('#ee-cart-share-css')) return;
    var st = document.createElement('style');
    st.id = 'ee-cart-share-css';
    st.textContent =
      '.ee-share-btn{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;margin-top:12px;padding:10px 0;border:0;background:none;color:#2F381C;font:inherit;font-size:1.4rem;letter-spacing:.04rem;cursor:pointer;text-decoration:underline;text-underline-offset:3px}' +
      '.ee-summary-head{display:flex;align-items:center;justify-content:space-between;gap:12px;background:#fff;margin:0 -20px;padding:0 20px 14px}.ee-summary-head>.ee-summary__title{flex:1;min-width:0;margin:0;padding:0;background:transparent}' +
      '.ee-share-btn.ee-share-btn--head{width:auto;flex:none;margin:0;padding:6px 0;font-size:1.35rem;white-space:nowrap}' +
      '.ee-share-dlg{width:min(480px,calc(100vw - 32px));padding:28px 24px 24px;border:0;border-radius:8px;box-shadow:0 20px 60px rgba(0,0,0,.25)}' +
      '.ee-share-dlg::backdrop{background:rgba(47,56,28,.45)}' +
      '.ee-share-dlg h3{margin:0 40px 6px 0}.ee-share-dlg p{margin:0 0 14px;color:rgba(18,19,19,.75);font-size:1.4rem}' +
      '.ee-share-x{position:absolute;top:10px;right:10px;width:36px;height:36px;border:0;border-radius:50%;background:#F4F2F0;color:#2F381C;font-size:22px;line-height:36px;cursor:pointer}' +
      '.ee-share-row{display:flex;gap:8px}.ee-share-row input{flex:1;min-width:0;padding:10px 12px;border:1px solid #D0CBC8;border-radius:6px;font:inherit;font-size:1.3rem;background:#F4F2F0;color:#121313}' +
      '.ee-share-row .button{min-width:0;padding:0 18px;min-height:44px;white-space:nowrap}' +
      '.ee-share-apps{display:flex;gap:8px;margin-top:12px}.ee-share-apps a{flex:1;min-width:0;padding:0 8px;min-height:42px;font-size:1.3rem}' +
      '.ee-share-note{margin-top:14px!important;font-size:1.2rem!important;color:#9D9185!important}' +
      '.ee-shared{margin:28px 0 24px;padding:18px 20px;background:#F0EBE6;border-left:3px solid #2F381C;border-radius:4px}' +
      '.ee-shared b{color:#2F381C}.ee-shared ul{margin:8px 0 12px;padding-left:1.2em;font-size:1.4rem}' +
      '.ee-shared__btns{display:flex;flex-wrap:wrap;gap:10px;align-items:center}.ee-shared__btns .button{min-height:44px}' +
      '.ee-shared__dismiss{border:0;background:none;font:inherit;font-size:1.3rem;text-decoration:underline;cursor:pointer;color:rgba(18,19,19,.7)}' +
      '.ee-shared__msg{margin-top:10px;font-size:1.35rem;color:#2F381C}';
    document.head.appendChild(st);
  }

  /* ---------- share (sender) ---------- */
  function buildLink() {
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('cart_read');
        return response.json();
      })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) throw new Error('empty');
        var items = cart.items.map(function (item) {
          var properties = {};
          Object.keys(item.properties || {}).forEach(function (key) {
            var value = item.properties[key];
            if (value !== '' && value != null) properties[key] = value;
          });
          return {
            id: String(item.variant_id),
            quantity: item.quantity,
            properties: properties
          };
        });
        return fetch('https://easeease-share-cart.easeease-service.workers.dev/api/share-cart', {
          method: 'POST',
          credentials: 'omit',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ cart: { items: items } })
        }).then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok || !data || !data.ok || !data.shareUrl) {
              throw new Error(data && data.error ? data.error : 'share_failed');
            }
            return { url: data.shareUrl, count: cart.item_count };
          });
        });
      });
  }

  function openDialog(link) {
    var dlg = $('#ee-share-dlg');
    if (!dlg) {
      dlg = document.createElement('dialog');
      dlg.id = 'ee-share-dlg';
      dlg.className = 'ee-share-dlg';
      document.body.appendChild(dlg);
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    }
    var text = 'Here is my curtain cart from EaseEase:';
    var enc = encodeURIComponent;
    dlg.innerHTML =
      '<button type="button" class="ee-share-x" aria-label="Close">&times;</button>' +
      '<h3 class="h3">Share this cart</h3>' +
      '<p>Anyone with this link can add the same items and options to their own cart.</p>' +
      '<div class="ee-share-row"><input type="text" readonly value="' + esc(link.url) + '" aria-label="Cart link"><button type="button" class="button" data-copy>Copy link</button></div>' +
      '<div class="ee-share-apps">' +
        '<a class="button button--secondary" href="mailto:?subject=' + enc('My EaseEase cart') + '&body=' + enc(text + '\n' + link.url) + '" data-m="email">Email</a>' +
        '<a class="button button--secondary" href="https://wa.me/?text=' + enc(text + ' ' + link.url) + '" target="_blank" rel="noopener" data-m="whatsapp">WhatsApp</a>' +
        '<a class="button button--secondary" href="sms:?&body=' + enc(text + ' ' + link.url) + '" data-m="sms">Text</a>' +
      '</div>' +
      '<p class="ee-share-note">Prices are recalculated when the cart is opened, so they always reflect current pricing.</p>';
    $('.ee-share-x', dlg).addEventListener('click', function () { dlg.close(); });
    var input = $('input', dlg), copyBtn = $('[data-copy]', dlg);
    copyBtn.addEventListener('click', function () {
      var done = function (copied) {
        copyBtn.textContent = copied ? 'Copied!' : 'Copy failed';
        setTimeout(function () { copyBtn.textContent = 'Copy link'; }, 2000);
      };
      var fallbackCopy = function () {
        input.focus();
        input.select();
        var copied = false;
        try { copied = document.execCommand('copy'); } catch (e) {}
        done(copied);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(link.url).then(function () { done(true); }, fallbackCopy);
      } else {
        fallbackCopy();
      }
      track('ee_cart_share', { method: 'copy', count: link.count });
    });
    Array.prototype.forEach.call(dlg.querySelectorAll('[data-m]'), function (a) {
      a.addEventListener('click', function () { track('ee_cart_share', { method: a.getAttribute('data-m'), count: link.count }); });
    });
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    input.focus(); input.select();
  }

  function addShareButton() {
    if ($('.ee-share-btn')) return;
    var anchor = $('.cart__ctas') || ($('#checkout') && $('#checkout').parentNode);
    if (!anchor) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ee-share-btn';
    b.innerHTML = SHARE_ICON + '<span>Share this cart</span>';
    b.addEventListener('click', function () {
      b.disabled = true;
      buildLink().then(function (link) {
        b.disabled = false;
        var mobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
        if (mobile && navigator.share) {
          navigator.share({ title: 'My EaseEase cart', text: 'Here is my curtain cart from EaseEase:', url: link.url })
            .then(function () { track('ee_cart_share', { method: 'native', count: link.count }); })
            .catch(function (err) { if (!err || err.name !== 'AbortError') openDialog(link); });
        } else {
          openDialog(link);
        }
      }).catch(function (error) {
        b.disabled = false;
        var notice = $('.ee-share-error', b.parentNode);
        if (!notice) {
          notice = document.createElement('p');
          notice.className = 'ee-share-error';
          notice.setAttribute('role', 'alert');
          b.parentNode.insertBefore(notice, b.nextSibling);
        }
        notice.textContent = error && error.message === 'empty'
          ? 'Your cart is empty.'
          : 'Could not create a share link. Please try again.';
      });
    });
    // top-right of the "Order summary" heading; fall back to below the checkout buttons
    var title = $('.ee-summary__title');
    if (title) {
      var head = title.parentNode.classList.contains('ee-summary-head') ? title.parentNode : null;
      if (!head) {
        head = document.createElement('div');
        head.className = 'ee-summary-head';
        title.parentNode.insertBefore(head, title);
        head.appendChild(title);
      }
      b.classList.add('ee-share-btn--head');
      head.appendChild(b);
      return;
    }
    var blocks = anchor.parentNode;
    var errs = null;
    for (var i = 0; i < blocks.children.length; i++) { if (blocks.children[i].id === 'cart-errors') { errs = blocks.children[i]; break; } }
    blocks.insertBefore(b, errs);
  }

  /* ---------- open shared cart (receiver) ---------- */
  function handleSharedLink() {
    if (location.pathname.split('/').filter(function (part) { return part; }).pop() !== 'cart') return;
    var match = location.search.match(new RegExp('[?&]' + PARAM + '=([^&#]+)'));
    if (!match) return;

    var key;
    try { key = decodeURIComponent(match[1]); } catch (e) { return; }
    if (!/^[a-zA-Z0-9_-]{1,128}$/.test(key)) return;

    var box = document.createElement('div');
    box.className = 'ee-shared';
    box.setAttribute('role', 'region');
    box.setAttribute('aria-label', 'Shared cart');
    box.innerHTML = '<b>Someone shared a cart with you</b>' +
      '<div class="ee-shared__msg" aria-live="polite">Loading shared cart…</div>';
    var host = $('#MainContent .page-width') || $('#MainContent') || document.body;
    host.insertBefore(box, host.firstChild);
    var msg = $('.ee-shared__msg', box);

    function cleanUrl() {
      try {
        var url = new URL(location.href);
        url.searchParams.delete(PARAM);
        history.replaceState(null, '', url.pathname + url.search + url.hash);
      } catch (e) {}
    }
    function showError(message) {
      msg.textContent = message;
      cleanUrl();
    }

    fetch('https://easeease-share-cart.easeease-service.workers.dev/api/shared-cart?key=' + encodeURIComponent(key), {
      credentials: 'omit',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || !data || !data.ok) {
          throw new Error(data && data.error ? data.error : 'shared_cart_unavailable');
        }
        return data;
      });
    }).then(function (data) {
      var sharedItems = data.cart && data.cart.items;
      if (!Array.isArray(sharedItems) || !sharedItems.length) throw new Error('empty_shared_cart');

      var items = sharedItems.map(function (item) {
        if (!item || !item.id || !Number.isFinite(Number(item.quantity)) || Number(item.quantity) < 1) {
          throw new Error('invalid_shared_item');
        }
        return {
          id: String(item.id),
          quantity: Math.floor(Number(item.quantity)),
          properties: item.properties && typeof item.properties === 'object' ? item.properties : {}
        };
      });
      var guardKey = 'ee_shared_cart_added_' + key;
      try {
        if (sessionStorage.getItem(guardKey)) {
          msg.textContent = 'This shared cart was already added in this tab session.';
          cleanUrl();
          return;
        }
      } catch (e) {}

      msg.textContent = items.length + (items.length === 1 ? ' item is' : ' items are') + ' ready to add to your cart.';
      var buttons = document.createElement('div');
      buttons.className = 'ee-shared__btns';
      buttons.innerHTML = '<button type="button" class="button" data-add>Add to my cart</button>' +
        '<button type="button" class="ee-shared__dismiss" data-dismiss>No thanks</button>';
      box.insertBefore(buttons, msg);

      $('[data-dismiss]', box).addEventListener('click', function () {
        box.remove();
        cleanUrl();
      });
      $('[data-add]', box).addEventListener('click', function () {
        var btn = this;
        btn.disabled = true;
        try { sessionStorage.setItem(guardKey, '1'); } catch (e) {}
        cleanUrl();
        msg.textContent = 'Adding items…';

        items.reduce(function (promise, item) {
          return promise.then(function (result) {
            return fetch(ROOT + 'cart/add.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [item] })
            }).then(function (response) {
              return response.json().catch(function () { return {}; }).then(function () {
                return { added: result.added + (response.ok ? 1 : 0) };
              });
            }).catch(function () {
              return { added: result.added };
            });
          });
        }, Promise.resolve({ added: 0 })).then(function (result) {
          track('ee_cart_share_add', { count: result.added, total: items.length });
          if (result.added === items.length) {
            msg.textContent = 'Items added. Refreshing your cart…';
            setTimeout(function () {
              location.replace(location.pathname + location.search + location.hash);
            }, 700);
            return;
          }
          msg.textContent = result.added
            ? ('Added ' + result.added + ' of ' + items.length + ' items. Some items may be unavailable.')
            : 'Could not add these items. They may be unavailable.';
        });
      });
      track('ee_cart_share_open', { count: items.length });
    }).catch(function (error) {
      var message = error && error.message === 'empty_shared_cart'
        ? 'This shared cart is empty.'
        : 'This shared cart is invalid or has expired.';
      showError(message);
    });
  }

  function boot() {
    injectStyles();
    addShareButton();
    handleSharedLink();
    // the cart footer is re-rendered after quantity changes; put the button back
    if (window.MutationObserver) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(addShareButton, 200); }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
